import React from 'react'
import ReactDOM from 'react-dom'

const DataContext = React.createContext({})

export default DataContext